import { get, post, del } from '../../util/secure_fetch.js';
import { EVENT_NAME as SavePublicLibraryUrlEvent } from '@adobe-fonts/site/events/SavePublicLibraryUrlEvent.js';
import { EVENT_NAME as DeletePublicLibraryUrlEvent } from '@adobe-fonts/site/events/DeletePublicLibraryUrlEvent.js';
import { EVENT_NAME as FetchSharedLibraryBookmarkEvent } from '@adobe-fonts/site/events/FetchSharedLibraryBookmarkEvent.js';

export class ShareableLibrary {
  handleSaveShareableLibrary = async (event) => {
    const detail = event.detail;
    try {
      await post('/shared_libraries', {
        body: JSON.stringify({ bookmark_id: detail.bookmarkId, public_id: detail.shareableId, private_id: detail.privateId,
          owner_id: detail.creatorId, allow_copy: detail.allowCopy, allow_follow: detail.allowFollow })
      });

    } catch (error) {
      console.error('Failed to persist shareable url data', error);
    }
  };

  handleDeleteShareableLibrary = async (event) => {
    const libraryId = event.detail?.libraryId;
    try {
      await del(`/shared_libraries/${libraryId}`);
    } catch (error) {
      console.error('Failed to delete shareable url data', error);
    }
  };

  handleFetchShareableLibrary = async (event) => {
    const libraryId = event.detail?.libraryId;
    try {
      const response = await get(`/shared_libraries/${libraryId}`);
      if (response.ok) {
        const data = await response.json();
        event.detail.callback(data['shared_library']['bookmark_id'], data['shared_library']['allow_copy'], data['shared_library']['allow_follow']);
      }
    } catch (error) {
      console.error('Failed to fetch shareable url data', error);
    }
  };
}

export function registerEventHandlers() {
  const shareableLibrary = new ShareableLibrary();
  document.addEventListener(SavePublicLibraryUrlEvent, shareableLibrary.handleSaveShareableLibrary);
  document.addEventListener(DeletePublicLibraryUrlEvent, shareableLibrary.handleDeleteShareableLibrary);
  document.addEventListener(FetchSharedLibraryBookmarkEvent, shareableLibrary.handleFetchShareableLibrary);
}
